<template>
  <div
    id="spotlightWhole"
  >
    <v-container fluid>
      <v-col
        cols="12"
        md="8"
        v-if="showPrintOption && printUrl"
      >
        <a
          :href="printUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          <v-btn
            class="ma-4"
            :style="{ backgroundColor: 'teal', color: '#FFFFFF' }"
          >
            Print
          </v-btn>
        </a>
      </v-col>
      <v-row>
        <v-col cols="12">
          <v-select
            :items="subjects"
            :value="selectedSubject"
            @change="changeSubject"
            label="Subject"
          />
          <CurriculumCard />
        </v-col>
        <v-col/>
        <v-row
          v-if="assignedWalts.length === 0">
          <v-alert
            :value="true"
            type="info"
            class="white--text"
            transition="scale-transition">
            No WALTs have been recently assigned.
          </v-alert>
        </v-row>

        <template v-if="activeComplete">
          <v-col
            cols="12"
            class="pb-0 pt-0"
            v-for="(assignedWalt, indexIds) in orderedActiveWalts"
            :key="indexIds">
            <spotlight-card
              :assigned-walt="assignedWalt"
              :skill-ee="skillEE"
              :enable-comment-button="true"
              :allow-comment="allowComment"
              :hide-working-towards="hideWorkingTowards"
              :custom-title-wt="customTitleWt"
              :hidetitledescription="hidetaskdescription"
              :show-walt-button-name="showWaltButtonName"
              @open-feedback-dialog="openFeedbackDialog" />
          </v-col>
          <v-col
            cols="12"
            class="pb-0 pt-0"
            v-for="(assignedWalt, indIds) in orderedCompleteWalts"
            :key="indIds">
            <spotlight-card
              :assigned-walt="assignedWalt"
              :hidetitledescription="hidetaskdescription"
              :skill-ee="skillEE"
              :enable-comment-button="true"
              :allow-comment="allowComment"
              :hide-working-towards="hideWorkingTowards"
              :custom-title-wt="customTitleWt"
              :show-walt-button-name="showWaltButtonName"
              @open-feedback-dialog="openFeedbackDialog" />
          </v-col>
        </template>

        <template v-else>
          <v-col
            cols="12"
            class="pb-0 pt-0"
            v-for="(assignedWalt, indexIds) in orderedWalts"
            :key="indexIds">
            <spotlight-card
              :assigned-walt="assignedWalt"
              :hidetitledescription="hidetaskdescription"
              :skill-ee="skillEE"
              :enable-comment-button="true"
              :allow-comment="allowComment"
              :hide-working-towards="hideWorkingTowards"
              :custom-title-wt="customTitleWt"
              :show-walt-button-name="showWaltButtonName"
              @open-feedback-dialog="openFeedbackDialog" />
          </v-col>
        </template>

      </v-row>

      <v-dialog
        v-model="commentDialog"
        v-if="allowComment">
        <v-card>
          <v-card-title class="pb-0 subtitle-1">Feedback</v-card-title>
          <v-card-text
            class="red--text pt-0 pb-0"
            v-if="commentErrorMsg !== ''">{{ commentErrorMsg }}</v-card-text>
          <v-card-text class="pb-0">
            <v-textarea
              auto-grow
              rows="3"
              name="comment-input"
              label="Enter a comment"
              v-model="comment"
            />
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="error"
              text
              @click.native="commentDialog = false; comment = ''; commentErrorMsg = ''">Close</v-btn>
            <v-spacer/>
            <v-btn
              color="primary"
              text
              @click.native="saveComment()">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="feedbackDialog"
        max-width="290px"
        v-else>
        <v-card>
          <v-card-title>Feedback</v-card-title>
          <v-card-text>
            <v-row
              class="fill-height"
              align="center"
              justify="space-around"

            >
              <v-tooltip
                top
                v-for="(feedback, i) in possibleFeedback"
                :key="i">
                <v-btn
                  icon
                  @click="saveFeedback(feedback.message)"
                  slot="activator">
                  <v-icon>{{ feedback.icon }}</v-icon>
                </v-btn>
                <span>{{ feedback.message }}</span>
              </v-tooltip>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="error"
              text
              @click.native="feedbackDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <v-btn
      v-if="!isIOS && assignedWalts.length !== 0"
      @click="captureAll"
    >
      Capture All
    </v-btn>
  </div>
</template>

<script>
import SpotlightCard from '../components/SpotlightCard'
import CurriculumCard from '../components/CurriculumCard'
import html2canvas from 'html2canvas'

var orderBy = require('lodash.orderby')

export default {
  components: {
    SpotlightCard,
    CurriculumCard,
    html2canvas
  },
  data: () => ({
    assignedWalts: {},
    skillEE: {},
    panel: [],
    subjects: ['ALL'],
    selectedSubject: 'ALL',
    showPrintOption: false,
    printUrl: '',
    hideWorkingTowards: false,
    allowComment: true,
    commentPSID: 0,
    commentTaskId: 0,

    // Comment dialog
    commentDialog: false,
    comment: '',
    commentErrorMsg: '',

    // Emoji feedback dialog
    feedbackDialog: false,
    possibleFeedback: [
      {
        icon: 'far fa-star',
        message: 'You\'re a star!'
      },
      {
        icon: 'far fa-heart',
        message: 'Love it!'
      },
      {
        icon: 'far fa-thumbs-up',
        message: 'Good job!'
      },
      {
        icon: 'far fa-smile',
        message: 'Awesome! :)'
      }
    ],
    customTitleWt: '',
    hidetaskdescription: false,
    showWaltButtonName: 'WALTs',

    activeWalts: {},
    completeWalts: {},
    activeComplete: false,
    isIOS: false,
    disableFeedback: false

  }),

  computed: {
    orderedWalts: function () {
      if (Object.keys(this.assignedWalts).length > 0) { // Check if assignedwalts array is not empty
        let obj = this.assignedWalts[Object.keys(this.assignedWalts)[0]]

        if ('sort_date' in obj) {
          return orderBy(this.assignedWalts, 'sort_date', 'desc')
        } else if ('date_published' in obj) { // Checking if date_published exists in obj, sort by published date if it is
          return orderBy(this.assignedWalts, 'date_published', 'desc')
        } else {
          return orderBy(this.assignedWalts, 'date_started', 'desc')
        }
      } else {
        return this.assignedWalts
      }
    },
    orderedCompleteWalts: function () {
      if (Object.keys(this.completeWalts).length > 0) { // Check if assignedwalts array is not empty
        let obj = this.completeWalts[Object.keys(this.completeWalts)[0]]

        if ('sort_date' in obj) {
          return orderBy(this.completeWalts, 'sort_date', 'desc')
        } else if ('date_published' in obj) { // Checking if date_published exists in obj, sort by published date if it is
          return orderBy(this.completeWalts, 'date_published', 'desc')
        } else {
          return orderBy(this.completeWalts, 'date_started', 'desc')
        }
      } else {
        return this.completeWalts
      }
    },
    orderedActiveWalts: function () {
      if (Object.keys(this.activeWalts).length > 0) { // Check if assignedwalts array is not empty
        let obj = this.activeWalts[Object.keys(this.activeWalts)[0]]

        if ('sort_date' in obj) {
          return orderBy(this.activeWalts, 'sort_date', 'desc')
        } else if ('date_published' in obj) { // Checking if date_published exists in obj, sort by published date if it is
          return orderBy(this.activeWalts, 'date_published', 'desc')
        } else {
          return orderBy(this.activeWalts, 'date_started', 'desc')
        }
      } else {
        return this.activeWalts
      }
    }
  },
  methods: {
    changeSubject: function (selection) {
      if (selection !== this.selectedSubject) {
        this.selectedSubject = selection

        this.$store.commit('loading', true)

        this.$http.get('pupilsV2/' + this.$store.state.Dbasename + '/' + this.$store.state.pupilId + '/spotlightV2/recentEvidenceV2/' + this.selectedSubject)
          .then(resp => {
            this.assignedWalts = resp.data.assignedWalts

            if (resp.data.activeComplete === true) {
              this.activeComplete = resp.data.activeComplete
              this.completeWalts = resp.data.completeWaltsToShow
              this.activeWalts = resp.data.activeWaltsToShow
            }
            this.skillEE = resp.data.skill_EE
            this.$store.commit('loading', false)
          })
      }
    },
    captureAll: function () {
      html2canvas(document.querySelector('#spotlightWhole'),
        { logging: true, letterRendering: 1, allowTaint: false, useCORS: true, scale: window.devicePixelRatio
        }).then(canvas => {
        var img = canvas.toDataURL('image/png')
        var link = document.createElement('a')
        link.download = 'spotlight.png'
        link.href = img
        link.click()
      })
        . catch(err => {
          console.log(err)
        })
    },

    openFeedbackDialog: function (psid, taskid) {
      this.commentPSID = psid
      this.commentTaskId = taskid

      if (this.allowComment) {
        this.commentDialog = true
      } else {
        if (this.disableFeedback !== true) {
          this.feedbackDialog = true
        }
      }
    },

    saveComment: function () {
      this.$store.commit('loading', true)
      var comment = this.comment
      var psid = this.commentPSID
      var cid = this.$store.state.userId
      var taskid = this.commentTaskId
      var pupilCommentId = this.$store.state.pupilId

      if (comment !== '') {
        this.$http.post('spotlightV2/postCommentV2/' + this.$store.state.Dbasename, {
          'psid': psid,
          'content': comment,
          'caregiverId': cid,
          'taskId': taskid,
          'pupilCommentId': pupilCommentId
        })
          .then(resp => {
            if (resp.data.success) {
              Object.keys(this.assignedWalts).forEach(key => {
                console.log(this.assignedWalts[key])
                var mainarr = this.assignedWalts[key]

                if (mainarr.psid === psid && taskid === 0) {
                  this.assignedWalts[key].learning = (typeof this.assignedWalts[key].learning !== 'undefined' && this.assignedWalts[key].learning instanceof Array) ? this.assignedWalts[key].learning : []

                  this.assignedWalts[key].learning.unshift({
                    author: this.$store.state.parentName,
                    content: resp.data.content,
                    formattedDate: resp.data.formattedDate,
                    type: 'Parent'
                  })
                }
              })

              this.commentDialog = false
              this.comment = ''
              this.commentErrorMsg = ''
              this.commentPSID = 0
              this.$store.commit('loading', false)
            } else {
              this.commentErrorMsg = 'Something happen'
              this.$store.commit('loading', false)
            }
          })
      } else {
        this.commentErrorMsg = 'Comment cannot be blank. Please enter a comment before saving.'
        this.$store.commit('loading', false)
      }
    },

    saveFeedback: function (message) {
      this.$store.commit('loading', true)
      var psid = this.commentPSID
      var cid = this.$store.state.userId
      var pupilCommentId = this.$store.state.pupilId
      var taskid = this.commentTaskId

      this.$http.post('spotlightV2/postCommentV2/' + this.$store.state.Dbasename, {
        'psid': psid,
        'content': message,
        'caregiverId': cid,
        'taskId': taskid,
        'pupilCommentId': pupilCommentId

      })
        .then(resp => {
          if (resp.data.success) {
            Object.keys(this.assignedWalts).forEach(key => {
              console.log(this.assignedWalts[key])
              var mainarr = this.assignedWalts[key]

              if (mainarr.psid === psid && taskid === 0) {
                this.assignedWalts[key].learning = (typeof this.assignedWalts[key].learning !== 'undefined' && this.assignedWalts[key].learning instanceof Array) ? this.assignedWalts[key].learning : []

                this.assignedWalts[key].learning.unshift({
                  author: this.$store.state.parentName,
                  content: resp.data.content,
                  formattedDate: resp.data.formattedDate,
                  type: 'Parent'
                })
              }
            })

            this.feedbackDialog = false
            this.commentPSID = 0
            this.$store.commit('loading', false)
          }
        })
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('toggle_dialog', true)

      vm.$http.get('configV2/atschoolSpotlightDisableParenCmtV2/' + vm.$store.state.Dbasename)
        .then(resp => {
          vm.$http.get('pupilsV2/' + vm.$store.state.Dbasename + '/' + vm.$store.state.userId + '/checkSpotlightCommentStatusV2')
            .then(response => {
              if (resp.data.configValue === '' && response.data.configValue !== vm.$store.state.userId.toString()) {
                vm.allowComment = true
              } else {
                vm.allowComment = false
              }
            })
        })

      vm.$http.get('spotlightV2/getSpotlightPrint/' + vm.$store.state.Dbasename + '/' + vm.$store.state.pupilId)
        .then(resp => {
          vm.showPrintOption = resp.data.spotlightConfig
          vm.printUrl = resp.data.url
        })

      // Get Subjects
      vm.$http.get('spotlightSubjectsV2/' + vm.$store.state.Dbasename)
        .then(resp => {
          vm.subjects = vm.subjects.concat(resp.data)
        })

      if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
        vm.isIOS = true
      }
      // Get WALTs
      vm.$http.get('pupilsV2/' + vm.$store.state.Dbasename + '/' + vm.$store.state.pupilId + '/spotlightV2/recentEvidenceV2')
        .then(resp => {
          vm.assignedWalts = resp.data.assignedWalts

          if (resp.data.activeComplete === true) {
            vm.activeComplete = resp.data.activeComplete
            vm.completeWalts = resp.data.completeWaltsToShow
            vm.activeWalts = resp.data.activeWaltsToShow
          }

          Object.keys(vm.assignedWalts).map((value, key) => {
            if (!vm.subjects.includes(vm.assignedWalts[value].subject)) {
              vm.subjects.push(vm.assignedWalts[value].subject)
            }
          })
          vm.skillEE = resp.data.skill_EE
          if (resp.data.hide_working_towards === true) {
            vm.hideWorkingTowards = true
          }

          vm.customTitleWt = resp.data.custom_title_wt
          if (resp.data.showWaltButtonName !== '') {
            vm.showWaltButtonName = resp.data.showWaltButtonName
          }

          vm.hidetaskdescription = resp.data.atschoolhidedescription
          vm.$store.commit('loading', false)
        })
    })
  },

  mounted () {
    this.$store.dispatch('logReadItems')
  }
}
</script>
